import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
Vue.use(Router);

// @ts-ignore
// @ts-ignore
// @ts-ignore
// @ts-ignore
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      // @ts-ignore
      hideFromNav: true,
      component: Login,
    },
    {
      path: '/login',
      name: 'Login',
      // @ts-ignore
      hideFromNav: true,
      component: Login,
    },
    {
      path: '/directory',
      name: 'Directory',
      // @ts-ignore
      hideFromNav: true,
      icon: 'search',
      // route level code-splitting: this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Directory" */ './views/Directory/index.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/manifests',
      name: 'Receiving',
        // @ts-ignore
      icon: 'mdi-file-document',
      hideFromNav: false,
      component: () => import(/* webpackChunkName: "Manifests" */ './views/Manifests/index.vue'),
      meta: {
          requiresAuth: true,
      },
    },
    {
      path: '/directory_v2',
      name: 'Customer Directory',
      // @ts-ignore
      icon: 'dashboard',
      // route level code-splitting: this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Directory" */ './views/DirectoryV2/index.vue'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {path: ":customer_id", component: () => import(/* webpackChunkName: "Directory" */ './views/DirectoryV2/customer.vue')}
      ]
    },
    {
      path: '/mailer',
      name: 'Mailer',
      // @ts-ignore
      icon: 'mdi-email',
      hideWhileTesting: true,
      // route level code-splitting: this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Directory" */ './views/Mail/index.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/mailer/:batch_id',
      name: 'Sent Mail',
      // @ts-ignore
      icon: 'mdi-email',
      hideFromNav: true,
      hideWhileTesting: true,
      // route level code-splitting: this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Directory" */ './views/Mail/WhoGotThisEmail.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/tracking',
      name: 'Tracking',
      // @ts-ignore
      icon: 'add_shopping_cart',
      hideFromNav: false,
      // route level code-splitting: this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // @ts-ignore
      component: () => import(/* webpackChunkName: "Released" */ './views/Tracking/index'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/logs',
      name: 'Logs',
      // @ts-ignore
      icon: 'folder_shared',
      noPerms: true,
      hideFromNav: true,
      component: () => import(/* webpackChunkName: "logs" */ './views/Logs/index.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/orders',
      name: 'Orders',
      // @ts-ignore
      icon: 'add_shopping_cart',
      hideFromNav: true,
      // route level code-splitting: this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Orders" */ './views/orders/index.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/billing',
      name: 'Billing',
      // @ts-ignore
      icon: 'attach_money',
      hideFromNav: true,
      // route level code-splitting: this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Billing" */ './views/billing_v1/Billing.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/billing_v2',
      name: 'Billing',
      // @ts-ignore
      icon: 'attach_money',
      hideFromNav: false,
      hideWhileTesting: true,
      // route level code-splitting: this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Billing" */ './views/Billing/index.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/release',
      name: 'Release',
      // @ts-ignore
      icon: 'mdi-beaker-check',
      hideFromNav: false,
      // route level code-splitting: this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Release" */ './views/ReleaseV2/index.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/hidden_releases',
      name: 'Hidden Releases',
      // @ts-ignore
      icon: 'mdi-file-hidden',
      hideFromNav: false,
      hideWhileTesting: true,
      // route level code-splitting: this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Release" */ './views/HiddenReleases/index.vue'),
      meta: {
        requiresAuth: true,
        badge: {
          dispatch: 'getHiddenReleases',
          notification: 'hidden_releases'
        }
      },
    },
    {
      path: '/heavy_metals',
      name: 'Heavy Metals',
      // @ts-ignore
      icon: 'mdi-beaker-check',
      hideFromNav: true,
      // route level code-splitting: this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "metal_release" */ './views/HeavyMetals/index.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/drivecal',
      name: 'Drive Calendar',
      // @ts-ignore
      icon: 'drive_eta',
      hideFromNav: true,
      // route level code-splitting: this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "drivecal" */ './views/driveCalendar/index.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/settings',
      name: 'Settings',
      // @ts-ignore
      hideFromNav: true,
      icon: '',
      component: () => import(/* webpackChunkName: "settings" */ './views/Settings.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/belit_config',
      name: 'Config',
      // @ts-ignore
      hideFromNav: false,
      hideWhileTesting: true,
      icon: 'settings',
      component: () => import(/* webpackChunkName: "settings" */ './views/Config/index.vue'),
      meta: {
        requiresAuth: true,
      },
    },
  ],
});
